import { render } from "./ContactList.vue?vue&type=template&id=454efe1e&scoped=true"
import script from "./ContactList.vue?vue&type=script&lang=js"
export * from "./ContactList.vue?vue&type=script&lang=js"

import "./ContactList.vue?vue&type=style&index=0&id=454efe1e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454efe1e"]])

export default __exports__